import { ICompanySummary } from './types'

export const PIE_LEGENDS_COLORS: Record<keyof ICompanySummary, string[]> = {
  industries: ['#2157C5', '#FFCC00', '#90ED7D', '#E200E7', '#00C2FF'],
  employees: ['#FFB0B0', '#FF6161', '#FFDBBD', '#F7A35C', '#FFEFB8'],
  companies: ['#7CB5EC', '#1DBFBF', '#90ED7D', '#F7A35C', '#E200E7'],
}
